import Vue from 'vue'
import { Indicator } from 'mint-ui'
import { registErrorHandler } from './request'

export function registLoginTimeoutErrorHandler ({ store, router }) {
  registErrorHandler({ id: 'loginTimeOut',
    handler: err => {
      if (Number(err.status) === 401) {
        if (store.state.userId !== null) {
          router.push('/login')
        }
        return true
      }
    } })
}

let INDICATOR_SEMAPHORE = 0
let loading

export function registRequestErrorHandler () {
  Vue.mixin({
    methods: {
      /**
       * 
       * @param {*} asyncFunc 执行的方法检查
       * @param {*} failFunc 失败对应的方法
       * @returns 
       */
      async catchError (asyncFunc, failFunc) {
        const isMobile = this.$root.isMobile
        if (isMobile) { // isMobile
          startLoading(Indicator.open)
          try {
            return await asyncFunc()
          } catch (err) {
            if (failFunc) failFunc(err);
            if (!err.handled) {
              this.$notice(err.message)
              err.handled = true
            }
            throw err
          } finally {
            closeLoading(Indicator.close)
          }
        } else { // PC
          loading = startLoading(this.$loading) || loading
          try {
            return await asyncFunc()
          } catch (err) {
            if (failFunc) failFunc(err);
            if (!err.handled) {
              this.$notify.error({
                title: 'error',
                message: err.message
              })
              err.handled = true
            }
            throw err
          } finally {
            closeLoading(() => loading.close())
          }
        }
      }
    }
  })
}

function startLoading(startFunc) {
  let response
  if (INDICATOR_SEMAPHORE === 0) {
    response = startFunc()
  }
  INDICATOR_SEMAPHORE ++
  return response
}

function closeLoading(endFunc) {
  INDICATOR_SEMAPHORE --
  if (INDICATOR_SEMAPHORE <= 0) {
    endFunc()
    INDICATOR_SEMAPHORE = 0
  }
}
